const WS_ACTION_TYPES = {
  WS: {
    INIT: 'WS_INIT',
    ERROR: 'WS_ERROR',
    ON_MESSAGES_LIST: 'ON_MESSAGES_LIST',
    ON_MESSAGES_DETAIL: 'ON_MESSAGES_DETAIL',
    ON_MESSAGES_DETAIL_UPDATE: 'ON_MESSAGES_DETAIL_UPDATE',
    ON_MESSAGES_ROUTE_LIST: 'ON_MESSAGES_ROUTE_LIST',
    ON_MESSAGES_DROP_ROUTE_LIST: 'ON_MESSAGES_DROP_ROUTE_LIST',
    ON_MESSAGES_ROUTE_WAYPOINT_DETAILS: 'ON_MESSAGES_ROUTE_WAYPOINT_DETAILS',
    ON_MESSAGES_FAVORITE_LIST: 'ON_MESSAGES_FAVORITE_LIST',
    ON_MESSAGES_RECENT_LIST: 'ON_MESSAGES_RECENT_LIST',
    ON_MESSAGES_QUICKLINKS: 'ON_MESSAGES_QUICKLINKS',
    ON_MESSAGES_TURN_BY_TURN: 'ON_MESSAGES_TURN_BY_TURN',
    ON_MESSAGES_DIALOG_CONTINUE: 'ON_MESSAGES_DIALOG_CONTINUE',
    ON_MESSAGES_DIALOG_CANCEL: 'ON_MESSAGES_DIALOG_CANCEL',
    ON_COMMANDS: 'WS_ON_COMMANDS',
  },
};

export default WS_ACTION_TYPES;
